import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';
import { buildSubmitPublicCampaignMailingResponseRequest, parsePublicCampaignMailingResponseReceipt } from './publicMailingResponseRequest';

/** Public callable boundary. It deliberately has no Firestore dependency. */
export async function submitPublicCampaignMailingResponse(input) {
  const request = buildSubmitPublicCampaignMailingResponseRequest(input);
  const callable = httpsCallable(functions, 'submitPublicCampaignMailingResponse');
  const result = await callable(request);
  return parsePublicCampaignMailingResponseReceipt(result?.data);
}
